<template>
  <div class="barometer-inner-wrapper">
    <div class="barometer-inner-header">
      <h2>Omzet per uur (Dyflexis)</h2>
      <!-- <h2>{{employeeNameArray[0]}}</h2>
      <h3>Week {{weeknr}}</h3>-->
    </div>

    <div class="barometer-canvas-wrapper">
      <canvas
        :id="canvasID"
        generateGradient="false"
        width="220"
        height="120"
      ></canvas>
    </div>
    <div class="barometer-footer">
      <div class="barometer-rate ma-0">
        <span v-if="revenuePerhour > 100" class="on-fire"></span>
        <div>
          <span>€ {{ revenuePerhour }} per uur</span>
        </div>
      </div>
      <!-- <p v-if="revenue" class="barometer-description">De doelstelling is om boven de 100% te blijven</p> -->
      <p
        v-if="dyflexis && dyflexisType == 'planned'"
        class="barometer-description"
      >
        Gebasseerd op {{ dyflexisHours.toFixed(1) }} geplande uren (Tot en met
        vandaag)
      </p>
      <p
        v-if="dyflexis && dyflexisType == 'worked'"
        class="barometer-description"
      >
        Gebasseerd op {{ dyflexisHours.toFixed(1) }} gewerkte uren
      </p>
      <div v-if="!dyflexis" class="barometer-alert">
        <v-alert :value="true" type="warning"
          >Medewerker is nog niet gekoppeld</v-alert
        >
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import db from "../../firebase/init";
import { bus } from "../../main";
import { log } from "util";
export default {
  props: [
    "level",
    "marks",
    "aperture",
    "colorStop",
    "colorStart",
    "canvasID",
    "rate",
    "employeeName",
    "employeeTarget",
    "weeknr",
    "revenue",
    "dyflexis",
    "dyflexisHours",
    "dyflexisType",
    "hourRateAmmount",
  ],
  name: "employeerBarometer",
  data: () => ({
    mini: true,
    employeeNameArray: [],
    id: null, //passed getal door
    width: 220,
    canvasRender: null,
    revenuePerhour: 0,
    actualPercentage: null, //Status Barometer employee
    opts: {
      angle: 0, /// The span of the gauge arc
      lineWidth: 0.26, // The line thickness
      pointer: {
        length: 0.7, // Relative to gauge radius
        strokeWidth: 0.035, // The thickness
        color: "#767676",
      },
      colorStop: "#333",
      colorStart: "#333",
      strokeColor: "rgb(204,204,204)",
      limitMax: true, // If false, max value increases automatically if value > maxValue
      generateGradient: false,
      highDpiSupport: true,

      // percentColors: [[0.0, "#a9d70b"], [0.5, "#f9c802"], [1.0, "#ff0000"]],
      // staticZones: [
      //   { strokeStyle: "rgb(204,204,204)", min: 0, max: 120, height: 1.0 },
      //   { strokeStyle: "rgb(255,255,255)", min: 99, max: 100, height: 1.2 }
      // ],
      staticLabels: {
        font: "14px sans-serif", // Specifies font
        labels: [100], // Print labels at these values
        color: "#000000", // Optional: Label text color
        fractionDigits: 0, // Optional: Numerical precision. 0=round off.
      },
      // pointer: {
      //   // Extra optional pointer options:
      //   iconPath: "myicon.png", // Icon image source
      //   iconScale: 1, // Size scaling factor
      //   iconAngle: 90.0 // Rotation offset angle, degrees
      // }
    },
  }),

  created() {
    bus.$on("employeeBarometerUpdate", this.updateData);
    this.opts.colorStop = this.colorStop;
  },

  mounted() {
    this.updateData();
  },

  filters: {
    roundmeFilter(value) {
      return value.toFixed(1); // thing to transform
    },
  },

  methods: {
    updateData() {
      let theMaxValue = 120;
      const splitEmployeeName = this.employeeName.split(" ");
      this.employeeNameArray = splitEmployeeName;

      if (this.dyflexisHours && this.revenue) {
        this.revenuePerhour = Number(
          (this.revenue / this.dyflexisHours).toFixed(0),
        );
        this.opts.staticLabels.labels = [];
        this.opts.staticLabels.labels.push(this.revenuePerhour);
      } else {
        this.revenuePerhour = 0;
      }

      let rate = 0;

      if (this.employeeTarget && this.employeeTarget.revenue) {
        rate = this.revenuePerhour;
        rate = Math.floor(
          (this.revenuePerhour / this.employeeTarget.revenue) * 100,
        );
        if (rate <= 25) {
          this.opts.colorStop = "#ff0a0a";
          this.opts.colorStart = "#ff0a0a";
        } else if (rate <= 50 && rate > 25) {
          this.opts.colorStop = "#f2ce02";
          this.opts.colorStart = "#f2ce02";
        } else if (rate <= 75 && rate > 50) {
          this.opts.colorStop = "#ebff0a";
          this.opts.colorStart = "#ebff0a";
        } else if (rate <= 100 && rate > 75) {
          this.opts.colorStop = "#85e62c";
          this.opts.colorStart = "#85e62c";
        } else if (rate > 100) {
          this.opts.colorStop = "#209c05";
          this.opts.colorStart = "#209c05";
        }
      }

      var opts = this.opts;
      var target = document.getElementById(this.canvasID); // Passeren langs DOM element
      var gauge = new Gauge(target).setOptions(opts); // Unieke Gauge opbouwn

      gauge.maxValue = theMaxValue; // max gauge value
      gauge.setMinValue(0); // min value
      gauge.set(rate); // actual valu0;
    },
  },

  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    // intel() {
    //   if (this.revenue == null) {
    //     return `<span style="">Er is nog geen doel voor deze medewerker ingesteld.</span>`;
    //     // return `<span style="">Er is nog geen doel voor ${this.employeeName} ingesteld.</span>`;
    //   } else {
    //     return `<span style="red">De doelstelling is om boven de 100% te blijven.</span>`;
    //     // return `<span style="red">De doelstelling voor ${this.employeeName} is rond de 100% te blijven.</span>`;
    //   }
    // }
  },
};
</script>
